/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

require('../../styles/risk.scss');

import React from 'react';
//import RiskAndSensationQuestion from './RiskAndSensationQuestion';
import RiskAndSensationQuestion from './RiskAndSensationQuestion';
import RiskAndSensationAnswer from './RiskAndSensationAnswer';
import RiskAndSensationOverlay from './RiskAndSensationOverlay';
import Sharing from '../Sharing';


class RiskAndSensation extends React.Component {
  constructor(props) {
    super(props);
    this._pageCount = 0;
    this._current = 0;
  }

  componentDidMount() {
    if (this.props.pages)
      this.updateArrow();
  }

  render() {
    var pages = [];
    if (!this.props.pages)
      return null
    this._pageCount = this.props.pages.length;
    //Page
    this.props.pages.forEach(page => {
      var cpt = pages.length;
      pages.push(
        <div className={"page page" + cpt + " " + (cpt == 0 ? "show" : "hideRight")} key={cpt + "C"}>
          <RiskAndSensationAnswer background={page.answer.background} title={page.answer.title} key={cpt + "B"} />
          <RiskAndSensationQuestion background={page.question.background} title={page.question.title} show={() => this.showAnswer()} key={cpt + "A"} />
        </div>
      );
    });

    return <div className={"riskSensation"} id="riskSensation">
      <a id="riskSensation"></a>
      {this.createOverlay()}
      <div className="pages">
        {pages.reverse()}
      </div>
    </div>
  }

  createOverlay(){
    return  <div className="overlay">
         <Sharing
          classes="sharing"
          hash="riskSensation"
          url={'http://guidesaventure.ca/episode/' + this.props.episode + '/risk/EP_' + this.props.episode + '_Q' + (this._current+1) + ''}
          twitterText="À voir"
        />
        <button className="arrow_btn left" onClick={() =>this.previous()}>previous</button>
        <button className="arrow_btn right" onClick={() =>this.next()}>next</button>
        <ul className="image-gallery-bullets">
          <li><button className="image-gallery-bullet active" onClick={() => this.select(0)}>page1</button></li>
          <li><button className="image-gallery-bullet" onClick={() => this.select(1)}>page2</button></li>
          <li><button className="image-gallery-bullet" onClick={() => this.select(2)}>page3</button></li>
        </ul>
      </div>
  }

  /**
   * Show answer page
   */
  showAnswer() {
    var page = document.querySelector(".riskSensation " + ".page" + this._current);
    var question = page.querySelector(".question");
    var answer = page.querySelector(".answer");
    question.classList.add("hideQuestion");
    answer.classList.add("visible");
    var actionHide = e => {
      question.classList.add("hide");
      question.removeEventListener("animationend", actionHide);
    }
    question.addEventListener("animationend", actionHide);
    this.fixSize(question);
  }

  updateArrow() {
    var left = document.querySelector(".arrow_btn.left")
    var right = document.querySelector(".arrow_btn.right")
    if (this._current == 0)
      left.style.display = "none";
    else
      left.style.display = "block";
    if (this._current >= this._pageCount - 1)
      right.style.display = "none";
    else
      right.style.display = "block";
  }

  /**
   * go to the next quextion
   */
  next() {
    this.select(this._current + 1);

  }

  /**
   * Go to the index page
   * @param {Number} index
   */
  select(index) {

    var prev = document.querySelector(".riskSensation " + ".page" + this._current);
    var next = document.querySelector(".riskSensation " + ".page" + index);
    var activeIndex = document.querySelector(".riskSensation .active");
    var nextActiveIndex = document.querySelectorAll(".riskSensation .image-gallery-bullet")[index];

    next.querySelector(".question").classList.remove("hideQuestion", "hide")
    if(index==this._current)
      return;

    prev.classList.remove("showLeft");
    prev.classList.remove("showRight");
    next.classList.remove("hideRight");
    next.classList.remove("hideLeft");

    if (index > this._current) {
      prev.classList.add("hideLeft");
      next.classList.add("showRight");
    }
    else {
      prev.classList.add("hideRight");
      next.classList.add("showLeft");
    }

    activeIndex.classList.remove("active");
    nextActiveIndex.classList.add("active");

    this._current = index;
    this.updateArrow();
    this.forceUpdate()
  }

  /**
   * go to the previous quextion
   */
  previous() {
    this.select(this._current - 1);
  }

  /**
   * Force content size for prevent animation deformation
   * @param {HTMLElement} element
   */
  fixSize(element) {
    var container = element.getElementsByClassName("container")[0];
    var rect = document.getElementById("riskSensation").getBoundingClientRect();
    container.style.width = rect.width + "px";
    container.style.height = rect.height + "px";
  }

  /**
   *
   * @param {HTMLElement} element
   */
  unfixSize(element) {
    var container = element.getElementsByClassName("container")[0];
    container.style.removeProperty("width")
    container.style.removeProperty("height")
  }
}

RiskAndSensation.propTypes = {
  pages: React.PropTypes.array,
};

RiskAndSensation.defaultProps = {
  pages: null
};


export default RiskAndSensation;



// WEBPACK FOOTER //
// ./src/components/riskAndSensation/RiskAndSensation.js